import {
  DeleteRelatedProductsRequest,
  RelatedProductsRequest,
} from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/RelatedProductsRequest';

export const generateRelatedProductsPayload = (
  originalRelatedProductsIds: number[],
  newRelatedProductsIds: number[],
) => {
  const relatedProductsToCreate: RelatedProductsRequest[] = [];
  const relatedProductsToDelete: DeleteRelatedProductsRequest[] = [];

  originalRelatedProductsIds.forEach((relatedProductId) => {
    if (!newRelatedProductsIds.includes(relatedProductId)) {
      relatedProductsToDelete.push({
        id: relatedProductId,
        '@delete': true,
      });
    }
  });

  newRelatedProductsIds.forEach((relatedProductId, index) => {
    const indexOfRelatedProductId =
      originalRelatedProductsIds.indexOf(relatedProductId);
    const positionChanged =
      indexOfRelatedProductId !== -1 && indexOfRelatedProductId !== index;
    if (
      !originalRelatedProductsIds.includes(relatedProductId) ||
      positionChanged
    ) {
      relatedProductsToCreate.push({
        id: relatedProductId,
        order: index + 1,
      });
    }
  });

  return [...relatedProductsToCreate, ...relatedProductsToDelete];
};
